(() => {
  const TOKEN = '34db81d9015f665389a0637fbd0d7d65';

  async function updateStockyETA(variantId) {
    const el = document.getElementById('stockyETA');
    if (!el || !variantId) return;

    el.hidden = true;
    el.textContent = '';

    try {
      const res = await fetch(
        `https://stocky.shopifyapps.com/api/v1/variants/${variantId}/purchase_order.json`,
        {
          headers: {
            Authorization: `Token token=${TOKEN}`,
          },
        }
      );

      if (!res.ok) return;

      const data = await res.json();

      if (!data.expected_on) return;

      if (data.late === true) {
        el.textContent = 'Should be back any day now!';
      } else {
        const date = new Date(`${data.expected_on}T00:00:00Z`);

        const formattedDate = new Intl.DateTimeFormat('en-AU', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        }).format(date);

        el.textContent = `Restock ${formattedDate}`;
      }

      el.hidden = false;
    } catch (err) {
      // fail silently (or console.warn(err) if you want visibility)
    }
  }

  /** Initial load */
  document.addEventListener('DOMContentLoaded', () => {
    const variantInput = document.querySelector('input[name="id"]');
    updateStockyETA(variantInput?.value);
  });

  /** Dawn variant change hook */
  document.addEventListener('variantChange', (event) => {
    updateStockyETA(event.detail?.variant?.id);
  });
})();
